import { Button, createStyles, WithStyles, withStyles } from '@material-ui/core';
import { FormikErrors } from 'formik';
import _ from 'lodash';
import { inject } from 'mobx-react';
import React from 'react';
import FullWidthField from 'src/common/FullWidthField';
import TypeAheadField from 'src/common/TypeAheadField/TypeAheadField';
import { IActionItem, IUser } from 'src/Definitions';
import { IStores } from 'src/Stores';
import { IActionItemFormValues } from '../ActionItemDialog';

const styles = () => createStyles({});

interface IAssigneeProps extends WithStyles<typeof styles> {
    actionItem?: IActionItem;
    assignees?: IUser[];
    errors: FormikErrors<IActionItemFormValues>;
    initialValues: IActionItemFormValues;
    getActionItemUsers?: (filter?: string) => Promise<void>;
    setFieldValue: (field: string, value: any) => void;
    values: any;
}

class Assignee extends React.Component<IAssigneeProps> {
    public componentDidMount() {
        this.props.getActionItemUsers!(
            this.props.actionItem ? this.props.actionItem.assigneeName : ''
        );
    }

    public render() {
        const {
            assignees,
            errors,
            initialValues,
            values,
            setFieldValue,
            getActionItemUsers,
        } = this.props;
        return (
            <>
                <TypeAheadField
                    outlined
                    label="User Search"
                    name="assigneeId"
                    inputId="assigneeId"
                    cypressLabel="assignee"
                    childCypressLabel="assignee"
                    errorMessage={errors.assigneeId}
                    fullWidth
                    setFieldValue={setFieldValue}
                    initialValue={this.getAssignee(
                        initialValues.assigneeId,
                        assignees!,
                        setFieldValue
                    )}
                    selectedValue={this.getAssignee(values.assigneeId, assignees!, setFieldValue)}
                    items={assignees}
                    getItems={getActionItemUsers}
                    getName={this.getAssigneeName}
                    getValue={this.getAssigneeValue}
                />
                <Button onClick={this.clear(setFieldValue)}>Clear</Button>
                <FullWidthField name="assigneeName" label="Assignee Name" />
                <FullWidthField name="assigneeEmail" label="Assignee Email" />
            </>
        );
    }

    public clear = (setFieldValue: (field: string, value: any) => void) => () => {
        setFieldValue('assigneeName', '');
        setFieldValue('assigneeEmail', '');
        setFieldValue('assigneeId', '');
    };

    private getAssigneeName(item: IUser) {
        return item ? item.name || '' : '';
    }

    private getAssigneeValue(item: IUser) {
        return item ? item.id || '' : '';
    }

    private getAssignee(
        assigneeId: string,
        assignees: IUser[],
        setFieldValue: (field: string, value: any) => void
    ) {
        const assignee = _.find(assignees, (x) => x.id === assigneeId);
        if (assignee) {
            setFieldValue('assigneeName', assignee.name);
            setFieldValue('assigneeEmail', assignee.email);
        }
        return assignee;
    }
}

const InjectedAssignee = inject<IStores, IAssigneeProps, Partial<IAssigneeProps>, any>(
    (stores: IStores) => ({
        assignees: stores.users.users,
        getActionItemUsers: stores.users.getActionItemUsers,
    })
)(withStyles(styles)(Assignee));

export default InjectedAssignee;



// WEBPACK FOOTER //
// ./src/actionItems/Assignee/Assignee.tsx